import { useNotifications } from './useNotifications';

export default function NotificationsList() {
  const { rows, loading, error, unreadCount, markRead } = useNotifications();

  return (
    <div className="container page">
      <div className="page-title-row">
        <div>
          <p className="eyebrow">Notifications</p>
          <h1>
            My Notifications
            {unreadCount > 0 && <span className="badge-count">{unreadCount}</span>}
          </h1>
        </div>
      </div>

      {loading ? (
        <div className="spinner" />
      ) : error ? (
        <div className="card empty">
          <h3>Couldn't load</h3>
          <p className="muted">{error}</p>
        </div>
      ) : rows.length === 0 ? (
        <div className="card empty">
          <h3>Nothing here yet</h3>
          <p className="muted">You'll see updates about your requests here.</p>
        </div>
      ) : (
        <div className="table-wrap">
          <table className="tbl tbl-compact">
            <thead>
              <tr>
                <th />
                <th>Title</th>
                <th>Details</th>
                <th>When</th>
                <th />
              </tr>
            </thead>
            <tbody>
              {rows.map((n) => (
                <tr key={n.id} style={{ fontWeight: n.isRead ? 400 : 700 }}>
                  <td>{!n.isRead && <span className="pill pill-info">New</span>}</td>
                  <td>{n.title}</td>
                  <td className="muted">{n.body}</td>
                  <td className="mono meta">{new Date(n.createdAt).toLocaleString()}</td>
                  <td>
                    {!n.isRead && (
                      <button className="btn btn-ghost btn-sm" onClick={() => void markRead(n.id)}>
                        Mark read
                      </button>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
